import { createContext, useContext } from 'react';

export type TModalContext = {
  changeTitle: (newTitle: string) => void;
  close: () => unknown;
  descriptionId: string;
};

export const ModalContext = createContext<TModalContext | null>(null);

export function useModalContext() {
  const context = useContext(ModalContext);

  if (!context) throw new Error('There is no ModalContext');

  return context;
}
